// extracted by mini-css-extract-plugin
export default {"wrapper":"FormIcon_wrapper__v5BQg"};